import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInformatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M20 33c7.18 0 13-5.82 13-13S27.18 7 20 7 7 12.82 7 20s5.82 13 13 13"
    />
    <path
      fill="#00215B"
      d="M18 33c-7.18 0-13-5.82-13-13S10.82 7 18 7s13 5.82 13 13h1c0-7.732-6.268-14-14-14S4 12.268 4 20s6.268 14 14 14z"
    />
    <path
      fill="#fff"
      d="M18.45 17.556h3.1V28h-3.1zM20 15.95q-.85 0-1.425-.568T18 13.975t.575-1.407T20 12t1.425.568q.575.569.575 1.407 0 .84-.575 1.408-.574.568-1.425.568"
    />
    <path
      fill="#F8BADD"
      d="M30 34a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInformatie);

export default ForwardRef;
